import { TagsTopicsTab } from './tags-topics-tab'
import { TagsQuestionsTab } from './tags-questions-tab'
import { TagsPeopleTab } from './tags-people-tab'
import { TagsOverviewTab } from './tags-overview-tab'
import { TagsQuizzesTab } from './tags-quizzes-tab'

export const tagsTabs = [
  TagsOverviewTab,
  TagsTopicsTab,
  TagsQuizzesTab,
  TagsQuestionsTab,
  TagsPeopleTab,
]
